/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import { computed } from '@ember/object';
import {
  sortBy,
  resolved,
} from '@linc-technologies/linced-common/utils/arrays';

export default class OverviewController extends Controller {
  @service
  options;

  @service
  strings;

  @service
  features;

  @alias('features.sidekickEnabled')
  sidekickEnabled;

  @tracked sortProp = 'fullName';
  @tracked sortDir = 'asc';

  @alias('model.group.currentLearners.length')
  numLearners;

  @computed('model.group.currentLearners.[]', 'sortProp', 'sortDir')
  get sortedLearners() {
    let people = sortBy(this.model.group.currentLearners, this.sortProp);

    return this.sortDir === 'asc' ? people : people.reverse();
  }

  @computed('model.currentGoal.linkedGoals.content.[]')
  get sortedCoreGoals() {
    let linkedGoals = this.get('model.currentGoal.linkedGoals') || [];
    return this.groupGoalsBySubcategory(linkedGoals);
  }

  @computed('model.currentGoal.priorLinkedGoals.content.[]')
  get sortedPriorGoals() {
    let linkedGoals = this.get('model.currentGoal.priorLinkedGoals') || [];
    return this.groupGoalsBySubcategory(linkedGoals);
  }

  @computed('model.currentGoal.futureLinkedGoals.content.[]')
  get sortedFutureGoals() {
    let linkedGoals = this.get('model.currentGoal.futureLinkedGoals') || [];
    return this.groupGoalsBySubcategory(linkedGoals);
  }

  // Helper method to group goals by subcategory label
  groupGoalsBySubcategory(goals) {
    // ensure goals are resolved upfront.
    return resolved(goals).reduce((acc, goal) => {
      let subcategoryLabel = goal.get('subcategory.label') || 'Other';

      if (!acc[subcategoryLabel]) {
        acc[subcategoryLabel] = [];
      }
      // Initialise the total count if it doesn't exist
      if (!acc.totalCount) {
        acc.totalCount = 0;
      }
      // Add the goal to the group, increment the subcategory count, and the total count
      acc[subcategoryLabel].push(goal);
      acc.totalCount += 1;

      return acc;
    }, {});
  }
}
